// dependencies
import React from "react";
import Head from "next/head";
import { SWRConfig } from "swr";

// containers
import ContactContainer from "../containers/Contact";

// constants
import { SEO_PAGE_VALUE_CONTACT } from "@cloudspire/legacy-resources/src/constants/seo";

// contexts
import { useConfiguration } from "@cloudspire/legacy-resources/src/contexts/configuration";
import { useRoute } from "@cloudspire/legacy-resources/src/contexts/route";
import { useRouters } from "@cloudspire/legacy-resources/src/contexts/routers";

// api
import { roomContactPage } from "@cloudspire/legacy-resources/src/api/room";

// helpers
import { seoGetContentRelayOnConfiguration } from "@cloudspire/legacy-resources/src/helpers/seo";
import {
  roomInChannel,
  roomIsStateEnabled,
} from "@cloudspire/legacy-resources/src/helpers/room";
import channelBuildHostFromConfiguration from "@cloudspire/shared/helpers/channel/buildHostFromConfiguration";

// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";
import { fetchFallback } from "@cloudspire/legacy-resources/src/libraries/utils/fetcher";

// errors
import { RoomNotFoundError } from "@cloudspire/legacy-resources/src/errors";

function ContactPage(props) {
  const { fallback } = props;

  const configuration = useConfiguration();
  const route = useRoute();
  const { frontRouter } = useRouters();

  return (
    <SWRConfig value={{ fallback }}>
      <Head>
        {seoGetContentRelayOnConfiguration({
          configuration,
          page: SEO_PAGE_VALUE_CONTACT,
        })}

        {/* Indique aux crawlers que la page courante ne doit pas être indexée avec des query-params. */}
        <link
          rel="canonical"
          href={generateUri({
            scheme: "https",
            host: channelBuildHostFromConfiguration({
              channelConfiguration: configuration,
              websiteType: "front",
            }),
            router: frontRouter,
            name: route.getName(),
            parameters: route.getParameters(),
            query: {},
          })}
        />
      </Head>
      <ContactContainer />
    </SWRConfig>
  );
}

ContactPage.getInitialProps = async (ctx) => {
  const { isomorphicFetcher, route, configuration } = ctx;

  const query = route.getUri().getParsedQuery();

  const roomReference = query.ref;

  if (roomReference) {
    const [contactPageRoomFallback, roomShow] = await fetchFallback({
      ...roomContactPage({
        reference: roomReference,
        configuration,
      }),
      fetcher: isomorphicFetcher,
    });

    if (
      !roomInChannel({
        room: roomShow.data,
        channelIdList: configuration.channel.children,
      })
    ) {
      // Si l'hébergement ne fait pas partie du channel courant.
      throw new RoomNotFoundError("", {});
    }

    if (!roomIsStateEnabled({ room: roomShow.data })) {
      // Si l'hébergement est différent du statut activé.
      throw new RoomNotFoundError("", {});
    }

    return {
      fallback: {
        ...contactPageRoomFallback,
      },
    };
  }

  return {
    fallback: {},
  };
};

export default ContactPage;
